export default {
  primary: {
    lighten1: '#382566',
    lighten2: '#4d3c76',
    lighten3: '#635587',
    lighten4: '#7a6e99',
    lighten5: '#8c81a6',
    base: '#2A165B',
    alpha1: 'rgba(157,148,179,0.3)',
    darken1: '#a69dba',
    darken2: '#b0a9c2',
    darken3: '#bbb4ca',
    darken4: '#cdc9d9'
  },
  'new-primary': '#2A165B',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#EF7D00',
  background: '#FFFFFF',
  publishing: '#6F3AF2',
  finished: '#28A745',
  qualityControl: '#EF7D00',
  aiProcessing: '#FFB800',
  uploading: '#999999'
}
